/* Getallen van een businesscase zoals lijst en pagina ze tonen (nl-NL). Niet te
 * berekenen is een streepje, nooit een nul (zie calculateBusinesscase). */

const JAAR = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 1 });
const PROCENT = new Intl.NumberFormat('nl-NL', { maximumFractionDigits: 1, minimumFractionDigits: 1 });

/** '2,4 jaar', '1 jaar'; zonder terugverdientijd binnen de looptijd een streepje. */
export const jaar = (v: number | null | undefined) => (v === null || v === undefined ? '—' : `${JAAR.format(v)} jaar`);

export const procent = (v: number | null | undefined) => (v === null || v === undefined || !Number.isFinite(v) ? '—' : `${PROCENT.format(v)}%`);
